// src/components/WhatsAppFab.js
import React from "react";
import "./WhatsAppFab.css"; // create this CSS file for styles

const WhatsAppFab = () => {
  return (
    <a
      href="https://wa.me/13464649730"
      className="whatsapp-fab"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <span className="whatsapp-text">How can I help you?</span>
      <img
        src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
        alt="WhatsApp Chat"
        className="whatsapp-icon"
      />
    </a>
  );
};

export default WhatsAppFab;
